import React from "react";

interface VerifiedIconProps {
  color?: string;
}

export const VerifiedIcon: React.FC<VerifiedIconProps> = ({
  color = "#bfa073",
}) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path
      d="M12 2L4 5V11C4 16.2 7.4 20.74 12 22C16.6 20.74 20 16.2 20 11V5L12 2Z"
      stroke={color}
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9 12L11 14L15 10"
      stroke={color}
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
